@if (allocationError()) {<p role="alert">{{ allocationError() | translate }}</p>}
@if ((selectedDay$ | async); as date) {
  <div class="allocation-shell">
    <header class="allocation-header">
      <div class="allocation-date-nav">
        <button class="date-nav-button"
          type="button"
          (click)="changeDate(-1)">
          <ion-icon name="chevron-back-outline"></ion-icon>
          <span>{{ 'schedule.navigation.previousDay' | translate }}</span>
        </button>

        <div class="date-display">
          @if (loading()) {
            <app-loading></app-loading>
          } @else {
            <div class="date-display__day">
              {{ 'general.weekdays.' + date.getDay() | translate }}
            </div>
            <app-selected-day id="schedule"
              [currentDay]="date | date:'dd.MM.yyyy'"
              (changed)="changeFullDate($event)"></app-selected-day>
            <div class="date-display__week">
              {{ 'schedule.week' | translate }} {{ weekNumber() }}
            </div>
          }
        </div>

        <button class="date-nav-button date-nav-button--end"
          type="button"
          (click)="changeDate(1)">
          <span>{{ 'schedule.navigation.nextDay' | translate }}</span>
          <ion-icon name="chevron-forward-outline"></ion-icon>
        </button>
      </div>
    </header>

    @if ({
      clients: clients$ | async,
      workers: workers$ | async
    }; as vm) {
      @if (loading() || vm.clients == null || vm.workers == null) {
        <div class="allocation-layout allocation-layout--loading"
          aria-hidden="true">
          <section class="allocation-card allocation-card--sites">
            <div class="allocation-card__header allocation-skeleton__header">
              <span class="allocation-skeleton allocation-skeleton--title"></span>
              <span class="allocation-skeleton allocation-skeleton--copy"></span>
            </div>

            <div class="site-cards">
              @for (_ of [0, 1, 2]; track $index) {
                <article class="site-card allocation-skeleton-card">
                  <div class="allocation-skeleton-card__header">
                    <span class="allocation-skeleton allocation-skeleton--line"></span>
                    <span class="allocation-skeleton allocation-skeleton--meta"></span>
                  </div>
                  <div class="allocation-skeleton-card__body">
                    <span class="allocation-skeleton allocation-skeleton--row"></span>
                    <span class="allocation-skeleton allocation-skeleton--row"></span>
                  </div>
                </article>
              }
            </div>
          </section>

          <aside class="allocation-card allocation-card--workers">
            <div class="allocation-card__header allocation-skeleton__header">
              <span class="allocation-skeleton allocation-skeleton--title"></span>
              <span class="allocation-skeleton allocation-skeleton--copy"></span>
            </div>

            <div class="resource-list">
              @for (_ of [0, 1, 2, 3]; track $index) {
                <div class="resource-row allocation-skeleton-row">
                  <span class="allocation-skeleton allocation-skeleton--avatar"></span>
                  <div class="allocation-skeleton-row__content">
                    <span class="allocation-skeleton allocation-skeleton--line"></span>
                    <span class="allocation-skeleton allocation-skeleton--meta"></span>
                  </div>
                </div>
              }
            </div>
          </aside>
        </div>
      } @else {
        <div class="allocation-layout">
          <section class="allocation-card allocation-card--sites">
            <div class="allocation-card__header">
              <div>
                <h3>{{ 'schedule.worksites' | translate }}</h3>
                <p>{{ 'schedule.info' | translate }}</p>
              </div>
            </div>

            @if (vm.clients.length === 0) {
              <div class="allocation-empty">
                {{ 'dashboard.noItems' | translate }}
              </div>
            }

            <div class="site-cards">
              @for (client of vm.clients; track client.client) {
                @for (site of client.sites; track site.guid) {
                  <article class="site-card"
                    [class.site-card--active-target]="activeTargetSiteGuid() === site.guid">
                    <div class="site-card__header">
                      <div class="site-card__title">
                        <button class="site-card__link"
                          type="button"
                          (click)="onSite(site.guid)">
                          {{ client.name }} / {{ site.name }}
                        </button>
                        @if (site.workers$ | async; as workers) {
                          <div class="site-card__meta">
                            <ion-icon name="people-outline"></ion-icon>
                            <span>{{ 'schedule.workerCount' | translate:{ count: workers.length } }}</span>
                          </div>
                        }
                      </div>
                      @if (client.logo) {
                        <img class="site-card__logo"
                          [src]="client.logo" />
                      }
                    </div>

                    <div class="drop-area"
                      [class.drag-over]="dragOverSiteGuid() === site.guid"
                      (drop)="drop($event, site)"
                      (dragover)="allowDrop($event)"
                      (dragenter)="onDragEnter(site.guid)"
                      (dragleave)="onDragLeave(site.guid)">
                      @if (site.workers$ | async; as workers) {
                        @if (workers.length > 0) {
                          <div class="assigned-list">
                            @for (user of workers; track user.guid) {
                              <div class="assigned-item">
                                <div class="assigned-item__main">
                                  <app-sign-status [user]="user"
                                    [site]="site"
                                    [date]="date"></app-sign-status>
                                  <button class="assigned-item__content"
                                    type="button"
                                    (click)="openAssignmentEditorForUser(user, site, date)">
                                    <strong>{{ user.displayName }}</strong>
                                    @if (user.machine$ | async; as machine) {
                                      <span class="assigned-item__info">{{ machine.name }}</span>
                                    }
                                    @if (user.information) {
                                      <span class="assigned-item__info">{{ user.information }}</span>
                                    }
                                  </button>
                                </div>

                                <div class="assigned-item__actions">
                                  <button class="assigned-action"
                                    type="button"
                                    (click)="onTicketList(user, site)">
                                    {{ 'schedule.ticketsButton' | translate }}
                                  </button>
                                  <button class="assigned-action"
                                    type="button"
                                    (click)="onLock(user, site)">
                                    {{ 'schedule.lockButton' | translate }}
                                  </button>
                                  @if (isLocked(site, user)) {
                                    <span class="assigned-item__lock">
                                      <ion-icon name="lock-closed-outline"></ion-icon>
                                    </span>
                                  }
                                  @if (roleS() === 'admin' && !isLocked(site, user)) {
                                    <button class="assigned-item__remove"
                                      type="button"
                                      (click)="removeWorker(user, site.schedule)">
                                      <ion-icon name="close-outline"></ion-icon>
                                    </button>
                                  }
                                </div>
                              </div>
                            }

                            <app-extra-persons [site]="site"
                              [workers]="workers"
                              [date]="date"></app-extra-persons>
                          </div>
                        } @else {
                          <div class="drop-area__empty">
                            {{ 'schedule.dropWorker' | translate }}
                          </div>
                        }
                      }
                    </div>

                    @if (['admin', 'worker'].includes(roleS())) {
                      <div class="site-card__actions">
                        <button class="site-card__add"
                          type="button"
                          (click)="addWorker(site)">
                          <ion-icon name="person-add-outline"></ion-icon>
                          <span>{{ 'schedule.add.worker' | translate }}</span>
                        </button>
                      </div>
                    }
                  </article>
                }
              }
            </div>
          </section>

          @if (activeTargetSiteGuid() != null) {
            <button class="mobile-picker-backdrop"
              type="button"
              [attr.aria-label]="'schedule.actions.closePicker' | translate"
              (click)="clearActiveTarget()"></button>
          }

          <aside class="allocation-card allocation-card--workers"
            [class.allocation-card--workers-mobile-open]="activeTargetSiteGuid() != null">
            <div class="allocation-card__header allocation-card__header--workers">
              @if (assignmentEditor(); as editor) {
                <div>
                  <h3>{{ 'schedule.editShift.title' | translate }}</h3>
                  <p>{{ editor.userName }} · {{ editor.site.name }}</p>
                </div>
              } @else {
                <div>
                  <h3>{{ 'nav.workers' | translate }}</h3>
                  @if (inlineSelectionHint(); as hint) {
                    <p>{{ hint }}</p>
                  }
                </div>
                <label class="toggle-filter">
                  <span>{{ 'schedule.showAllWorkers' | translate }}</span>
                  <ion-toggle color="light"
                    [(ngModel)]="showAllUsers"></ion-toggle>
                </label>
              }
              <button class="mobile-picker-close"
                type="button"
                [attr.aria-label]="'schedule.actions.closePicker' | translate"
                (click)="assignmentEditor() ? closeAssignmentEditor() : clearActiveTarget()">
                <ion-icon name="close-outline"></ion-icon>
              </button>
            </div>

            @if (assignmentEditor(); as editor) {
              <div class="assignment-editor">
                <div class="assignment-editor__field">
                  <label>{{ 'schedule.editShift.labels.date' | translate }}</label>
                  <span>{{ editor.date | date:'d.M.yyyy' }}</span>
                </div>

                <div class="assignment-editor__grid">
                  <label class="assignment-editor__field">
                    <span>{{ 'schedule.editShift.labels.start' | translate }}</span>
                    <input type="time"
                      [value]="editStart()"
                      (input)="editStart.set($any($event.target).value)" />
                  </label>

                  <label class="assignment-editor__field">
                    <span>{{ 'schedule.editShift.labels.end' | translate }}</span>
                    <input type="time"
                      [value]="editEnd()"
                      (input)="editEnd.set($any($event.target).value)" />
                  </label>
                </div>

                <label class="assignment-editor__field">
                  <span>{{ 'schedule.editShift.labels.notes' | translate }}</span>
                  <textarea rows="4"
                    [value]="editInfoText()"
                    (input)="updateEditInfoText($any($event.target).value)"></textarea>
                </label>

                <div class="assignment-editor__actions">
                  <button class="assigned-action"
                    type="button"
                    (click)="closeAssignmentEditor()">
                    {{ 'general.cancel' | translate }}
                  </button>
                  <button class="assigned-action assigned-action--danger"
                    type="button"
                    (click)="deleteAssignmentEdit()">
                    {{ 'general.delete' | translate }}
                  </button>
                  <button class="assigned-action assigned-action--primary"
                    type="button"
                    (click)="saveAssignmentEdit()">
                    {{ 'general.save' | translate }}
                  </button>
                </div>
              </div>
            } @else {
              <div class="resource-list"
                [class.resource-list--selecting]="activeTargetSiteGuid() != null">
                @for (worker of vm.workers; track worker.guid) {
                  <button class="resource-row"
                    type="button"
                    [id]="worker.guid"
                    [class.inactive]="worker.inactive"
                    [class.resource-row--selecting]="activeTargetSiteGuid() != null"
                    draggable="true"
                    (dragstart)="drag($event)"
                    (click)="onUser(worker)">
                    <div class="resource-row__avatar">
                      @if (worker.image) {
                        <img [src]="worker.image" />
                      } @else {
                        <ion-icon name="person-circle-outline"></ion-icon>
                      }
                    </div>

                    <div class="resource-row__content">
                      <strong>{{ worker.displayName }}</strong>
                      <span>{{ worker.address?.city }}</span>
                      @if (worker.workType === 'fullTime') {
                        <span>{{ 'schedule.fullTimeWeekHours' | translate:{ hours: 40 } }}</span>
                      }
                    </div>

                    <div class="resource-row__langs">
                      @for (lang of worker.languages; track lang) {
                        <img src="./assets/images/lang/{{ lang }}.png" />
                      }
                    </div>
                  </button>
                } @empty {
                  <div class="allocation-empty">
                    {{ 'schedule.noFreeWorkers' | translate }}
                  </div>
                }
              </div>
            }
          </aside>
        </div>
      }
    }
  </div>
}
